import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { ToastType } from "@/enums";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayToast } from "@/utils/toast";

interface SetDefaultWorkspaceBody {
  workspace_id: number;
  organization_member_id: number;
}

export const useSetDefaultWorkspace = () => {
  const userToken = useUserToken();
  const queryClient = useQueryClient();

  return useMutation(
    (body: SetDefaultWorkspaceBody): Promise<{ message: string; success: boolean }> =>
      fetch(ENDPOINTS.set_default_workspace, {
        method: "PATCH",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify(body),
      }).then(handleResponse),
    {
      onSuccess: () => {
        displayToast("Default workspace set successfully", ToastType.success);
        queryClient.invalidateQueries({
          queryKey: [ENDPOINTS.get_workspaces],
        });
        queryClient.invalidateQueries({
          queryKey: [ENDPOINTS.organization_members],
        });
        queryClient.invalidateQueries({
          queryKey: [ENDPOINTS.me],
        });
      },
    },
  );
};
